/* eslint-disable semi */
/* eslint-disable semi */
/* eslint-disable no-undef */
'use strict';

import { gsap } from 'gsap';

const image = document.querySelector('.image');
const objet = document.querySelector('.obj');
const etiquette = document.querySelector('.etiquette--jeu');
const jeu = document.querySelector('.section--jeu');
const blocks = document.querySelector('.block');

export {
  objet,
  image,
  etiquette,
  blocks,
  jeu
};

const saveResultToLocalStorage = (item, result) => {
  const resultsFromLocalStorage = localStorage.getItem('results');

  const storedResults = resultsFromLocalStorage
    ? JSON.parse(resultsFromLocalStorage)
    : []

  storedResults.push({
    ...item,
    result
  })

  localStorage.setItem('results', JSON.stringify(storedResults));
}

// importer fichier json
if (etiquette) {
  fetch('./scripts/jeu.json ')
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const city = localStorage.getItem('city');

      const cities = {
        namur: 'namur',
        ath: 'ath',
        libramont: 'libramont',
        walhain: 'walhain'
      }

      const carreResiduel = document.querySelector('.carre--2');
      const SpecSquare = document.querySelector('.carre--5');
      const carreOrga = document.querySelector('.carre--1');
      const block = document.querySelectorAll('.carres');

      switch (city) {
        case 'namur':
          break
        case 'ath':
          carreOrga.classList.add('btn--hidden');
          carreResiduel.classList.add('btn--hidden');
          SpecSquare.classList.remove('btn--hidden');

          ranking(block);
          break;
        case 'libramont':
          carreResiduel.style.backgroundImage = 'url(./assets/images/sac-gris.svg)';
          carreResiduel.style.border = '3px solid #7F7F7F';
          break;
        case 'walhain':
          break;
        default:
          break;
      }

      const tableau = json[cities[city]];

      const shuffledArray = tableau.sort(() => 0.5 - Math.random());

      cityChoice(shuffledArray);
    })

  function ranking () {
    const blocky = document.querySelector('.block');
    blocky.style.display = 'flex';
    blocky.style.flexWrap = 'wrap-reverse';
  }

  // drag and drop
  function cityChoice (json) {
    const firstItem = json[0];
    etiquette.innerHTML = firstItem.nom;
    image.setAttribute('src', firstItem.img);
    image.dataset.etiquette = firstItem.nom;

    const block = document.querySelectorAll('.carres');
    block.forEach(carres => {
      carres.addEventListener('dragenter', dragEnter);
      carres.addEventListener('dragover', dragOver);
      carres.addEventListener('dragleave', dragLeave);
      carres.addEventListener('drop', drop);
    })

    objet.addEventListener('dragstart', dragStart);
    objet.addEventListener('dragend', dragend);

    function dragend (e) {
      e.target.classList.remove('btn--hidden');
    }

    function dragStart (e) {
      e.dataTransfer.setData('text/plain', e.target.dataset.etiquette);
      setTimeout(() => {
        e.target.classList.add('btn--hidden');
      }, 0)
    }

    function dragEnter (e) {
      e.preventDefault();
      e.target.classList.add('drag-over');
      const currentElementText = e.target.querySelector('p');
      const tla = gsap.timeline({ ease: Elastic.easeOut });
      tla.to(currentElementText, { opacity: 0, duration: 0.2 });
    }

    function dragOver (e) {
      e.preventDefault();
      e.target.classList.add('drag-over');
      const tlb = gsap.timeline({ ease: Elastic.easeOut });
      tlb.to(e.target, { backgroundSize: '80%' });
      e.target.setAttribute('src', '');
      return false;
    }

    function dragLeave (e) {
      const currentElementText = e.target.querySelector('p');
      const tlb = gsap.timeline({ ease: Elastic.easeOut });
      tlb.to('.drag-over', { backgroundSize: '60%' });
      tlb.to(currentElementText, { opacity: 1, duration: 0.1 });
      const source = e.target.getAttribute('src');
      e.target.setAttribute('src', source);
      e.target.classList.remove('drag-over');
    }

    let tablFrom = 0;
    const tablTo = 14;

    const jaugeE = document.querySelector('.jauge--ecolo');
    const jaugeD = document.querySelector('.jauge--detritus');

    const ecoloElements = jaugeE.querySelectorAll('.jauge--ecoloEl');
    const detritusElements = jaugeD.querySelectorAll('.jauge--detritusEl');

    let ecoloPoints = 0;
    let detritusPoints = 0;
    const ecoloPointsMax = 10;
    const detritusPointsMax = 5;

    function drop (e) {
      e.preventDefault();

      const droppedElementEtiquette = e.dataTransfer.getData('text/plain');

      const currentElementText = e.target.querySelector('p');
      const tlb = gsap.timeline({ ease: Elastic.easeOut });
      tlb.to('.drag-over', { backgroundSize: '60%' });
      tlb.to(currentElementText, { opacity: 1, duration: 0.1 });

      if (tablFrom <= tablTo) {
        const nameBlock = e.currentTarget.getAttribute('data-name');

        const droppedItem = json.find((item) => item.nom === droppedElementEtiquette);

        const success = droppedItem.reponse === nameBlock;

        saveResultToLocalStorage(droppedItem, success);

        if (success) {
          const audio3 = document.querySelector('.audio3');
          audio3.src = 'assets/musique/bon.mp3';
          audio3.play();
          audio3.volume = 0.5;

          const tl0 = gsap.timeline();
          tl0.to(jaugeE, { scale: 2, y: 100, x: -25, duration: 0.6 });
          tl0.to(ecoloElements[ecoloPoints], { fill: '#1C8434', duration: 0.2 });
          tl0.to(ecoloElements[ecoloPoints], { fill: '#ddd3d7', duration: 0.2 });
          tl0.to(ecoloElements[ecoloPoints], { fill: '#1C8434', duration: 0.2 });
          tl0.to(jaugeE, { scale: 1, y: 0, x: 0, duration: 0.8 });
          ecoloPoints++;

          if (ecoloPoints >= ecoloPointsMax) {
            window.location = 'http://aurelie-louage.be/projets/tfe/reussi.html';
            localStorage.setItem('ecolo', ecoloPoints);
            localStorage.setItem('detritus', detritusPoints);
            const resultsDetritus = localStorage.getItem('detritus');
            detritusElements[resultsDetritus].style.fill = '#846565';
          }
        } else {
          const audio3 = document.querySelector('.audio3');
          audio3.src = 'assets/musique/mauvaismodif.mp3';
          audio3.play();
          audio3.volume = 0.5;

          const tl0 = gsap.timeline();
          tl0.to(jaugeD, { scale: 2, y: 100, x: -100, duration: 0.6 });
          tl0.to(detritusElements[detritusPoints], { fill: '#843535', duration: 0.2 });
          tl0.to(detritusElements[detritusPoints], { fill: '#ddd3d7', duration: 0.2 });
          tl0.to(detritusElements[detritusPoints], { fill: '#843535', duration: 0.2 });
          tl0.to(jaugeD, { scale: 1, y: 0, x: 0, duration: 0.8 });
          detritusPoints++

          if (detritusPoints >= detritusPointsMax) {
            window.location = 'http://aurelie-louage.be/projets/tfe/rate.html';
            localStorage.setItem('ecolo', ecoloPoints);
            localStorage.setItem('detritus', detritusPoints);
          }
        }

        tablFrom++;

        const itemName = json[tablFrom].nom;

        image.setAttribute('src', json[tablFrom].img);
        image.dataset.etiquette = itemName;
        etiquette.innerHTML = itemName;
      }
    }
  }
}

// animation objet dans le jeu
if (objet) {
  const tl10 = gsap.timeline({ repeat: -1, yoyo: true });
  tl10.to('.obj', { x: 0, transform: 'rotate(-10deg)' });
  tl10.to('.obj', { x: 0, transform: 'rotate(10deg)' });
}

// position du block en fonction de la taille de l'écran
if (jeu) {
  if (window.matchMedia('(min-width: 1023px)').matches) {
    blocks.style.top = '330px';
  } else if ((window.matchMedia('(min-width: 810px)').matches)) {
    blocks.style.top = '260px';
  } else if ((window.matchMedia('(min-width: 767px)').matches)) {
    blocks.style.top = '210px';
  } else if ((window.matchMedia('(min-width: 410px)').matches)) {
    blocks.style.top = '190px';
  } else if ((window.matchMedia('(min-width: 360px) and (max-width: 409px)').matches)) {
    blocks.style.top = '150px';
  }
}
